import React from 'react';
import SideMenu from '@v2/shared/Layouts/SideMenu';
import { accountMenu } from '@v2/shared/Layouts/Account/menu';
import { AccountLayoutProps } from '@v2/shared/lib/types';
import Full from '../Full';

/**
 * The shell the signed-in customer's pages share, in MagSpot's chrome.
 *
 * TopMags' Account layout, brand for brand: the same name, the same props and the same
 * rail, resolved by brand exactly as `Layouts.Full` is. A page declares
 * `layoutName = 'Layouts.Account'` and gets its own brand's version without knowing which
 * brand it is on.
 *
 * No Container here, and none in the other brands' either: every brand's Full draws it
 * along with the padding inside it, so a layout over Full never has to ask whether it has
 * been boxed already. What is left for a brand to say is what it actually disagrees
 * about, and MagSpot disagrees about nothing but its chrome.
 */
export default function Account({
  children,
  autoRenewServiceName,
  autoRenewUrl,
  activePath,
  ...fullProps
}: AccountLayoutProps) {
  return (
    <Full {...fullProps}>
      {/* No digital library, as on TopMags: MagSpot does not sell digital editions and
          has never had one. See accountMenu. */}
      <SideMenu
        label="Account"
        groups={accountMenu({ autoRenewServiceName, autoRenewUrl })}
        activePath={activePath}
      >
        {children}
      </SideMenu>
    </Full>
  );
}
